export { default } from "./GlobalStyles.mjs";
export * from "./GlobalStyles.mjs";